import {
  Component,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  SimpleChanges
} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {debounceTime, map, switchMap, tap} from 'rxjs/operators';
import {SearchService} from '../search.service';
import {Product} from '@uofu-uss-aux/software-catalog-ng-core';
import {Observable, of, Subscription} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {sortBy} from 'lodash-es';
import {SearchIconComponent} from '../../svg/search-icon/search-icon.component';
import {ArrowRightIconComponent} from '../../svg/arrow-right-icon/arrow-right-icon.component';
import {XIconComponent} from '../../svg/x-icon/x-icon.component';
import {SearchResultComponent} from '../search-result/search-result.component';
import {RouterLink} from "@angular/router";


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: true,
  imports: [
    SearchIconComponent,
    ArrowRightIconComponent,
    XIconComponent,
    ReactiveFormsModule,
    SearchResultComponent,
    NgIf,
    NgForOf,
    RouterLink
  ]
})
export class SearchComponent implements OnInit, OnDestroy, OnChanges {

  static readonly timeToDebounce = 500;

  searchForm: UntypedFormGroup;

  @Input()
  products: ReadonlyArray<Product> = [];
  searchResults: ReadonlyArray<Product> = [];

  private _searching: string;
  private subscription: Subscription;

  constructor(private readonly searchService: SearchService,
              fb: UntypedFormBuilder,
              @Inject(PLATFORM_ID) private platform: string
  ) {
    this.searchForm = fb.group({
      searchControl: fb.control(''),
    });
  }

  ngOnInit() {
    this.subscription =
      this.searchForm.controls.searchControl.valueChanges
        .pipe(debounceTime(SearchComponent.timeToDebounce),
          tap(v => {
            this.searchResults = [];
            this._searching = v;
          }),
          switchMap(v => this.search(v, this.products)))
        .subscribe((results) => this.searchResults = results);
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasProducts) {
      this.searchForm.controls.searchControl.disable();
    } else {
      this.searchForm.controls.searchControl.enable();
    }
  }

  search(input: string, products: ReadonlyArray<Product>): Observable<ReadonlyArray<Product>> {
    if (input && input.length && products) {
      return this.searchService.search(input, products).pipe(
        map(arr => sortBy(arr, (product) => product.title.toLowerCase()))
      );
    } else {
      return of([]);
    }
  }

  get searching(): boolean {
    return !!this._searching && !!this._searching.length;
  }

  get hasSearchResults(): boolean {
    return !!this.searchResults && !!this.searchResults.length;
  }

  get hasProducts(): boolean {
    return !!this.products && !!this.products.length;
  }

  toggle() {
    this.searchService.toggleSearch();
  }

  show() {
    this.searchService.enableSearch();
  }

  hide() {
    this.searchService.disableSearch();
  }

  @HostListener('click', ['$event'])
  handleClickOffOverlay(event: MouseEvent) {
    if (isPlatformBrowser(this.platform)) {
      if (event.target instanceof HTMLElement && event.target.classList.contains('search-overlay-dim')) {
        this.hide();
      }
    }
  }
}
